import Request from "utils/requests/api";
import initializeConfig from "utils/requests/api.config";
import RequestToken from "utils/requests/identityApi";

export const BASE_URL = async () => {
  const { identity } = await initializeConfig();
  return `${identity}`;
};

export type ILocation = {
  id: number;
  description: string;
};

export interface IRequestPostNewUser {
  location: ILocation;
  name: string;
  email: string;
  language: string;
}

export interface IRequestToken {
  token: string;
}

export const saveNewUser = async (params: IRequestPostNewUser) => {
  const baseUrl = await BASE_URL();
  return (await Request).post(`${baseUrl}users`, params);
};

export const getYmsToken = async ({ token }: IRequestToken) => {
  const baseUrl = await BASE_URL();
  const requestAuth = await RequestToken;

  return requestAuth.get(`${baseUrl}authentications:token`, { token });
};

export const getLocations = async () => {
  const baseUrl = await BASE_URL();
  return (await Request).get(`${baseUrl}users:locations`);
};

export const updateLocation = async ({ id }) => {
  const baseUrl = await BASE_URL();
  return (await Request).put(`${baseUrl}users:location`, { id });
};
